import { defer } from 'react-router-dom'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { isAppStateReady } from 'src/state/store'
import { leaveRequestService } from '$services'
import { LeaveRequestStatus } from '$constants'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in employee Leave Status loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in employee Leave Status loader'
  )

  // Grab url params
  const {
    company: companyName,
    firstname: firstName,
    lastname: lastName,
    requestId,
    status,
    type: leaveTypeName,
  } = queryParams

  // NOTE that it is expected requests to this loader will happen on a page
  // with a one time token. This means you can't make API calls to our normal
  // backend as the user will most likely _not_ be authenticated. Data that
  // needs to be displayed can be included as url query params where appropriate.

  // Immediately process the status update, the response this to single API call
  // is used for the display on the page about to be loaded.
  const updatedLeaveRequest = leaveRequestService.updateStatus(
    requestId,
    status as unknown as LeaveRequestStatus
  )

  return defer({
    data: Promise.all([
      updatedLeaveRequest,
      companyName,
      leaveTypeName,
      firstName,
      lastName,
    ])
      .then((result) => {
        return result
      })
      .catch((error) => {
        logger.error('Employee Leave Status Promise.all error', error)
        return [undefined, undefined, undefined, undefined, undefined]
      }),
  })
}
